import { render, staticRenderFns } from "./YclientsMessagesBlock.vue?vue&type=template&id=7bd9b92c&scoped=true"
import script from "./YclientsMessagesBlock.vue?vue&type=script&lang=js"
export * from "./YclientsMessagesBlock.vue?vue&type=script&lang=js"
import style0 from "./YclientsMessagesBlock.vue?vue&type=style&index=0&id=7bd9b92c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd9b92c",
  null
  
)

export default component.exports